import { handleFirebaseError } from '../../../error-handling';
import { addMemberToOrganization } from '../addMemberToOrganization';

export async function addInstructorToOrganization(
  organizationId: string,
  instructorId: string,
  addedBy: string
): Promise<boolean> {
  try {
    return await addMemberToOrganization(organizationId, instructorId, 'instructor', addedBy);
  } catch (error) {
    handleFirebaseError(error, 'Error adding instructor to organization');
    return false;
  }
}